<template>
  <v-btn
    color="pwt_palatinate_blue"
    block
    variant="text"
    :disabled="disabled"
    :loading="loading"
    class="text-none rounded-lg text-decoration-underline"
    @click="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">

interface Props {
  loading?: boolean
  disabled?: boolean
}

const { loading = false, disabled = false } = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
